import React from 'react';
import { LoadingSpinner } from 'App/components/utils/LoadingSpinner';
import { TariffSubStep1 } from './tariff-sub-steps/TariffSubStep1';
import { TariffSubStep2 } from './tariff-sub-steps/TariffSubStep2';
import { IActiveStepType, IProductDataGM } from '../GarantieMax';
import { ILeadData } from 'Services/widgets/interfaces';
import { AppAlertUI } from 'App/components/utils/alerts/AppAlertService';
import { Col, Row } from 'react-bootstrap';

export interface ISubStep {
  subStep: IActiveStepType;
  productCode: string;
  lead: ILeadData;
  productData: IProductDataGM;
}

export const TariffStep: React.FC<ISubStep> = ( props ) => {
  const { subStep, productCode, lead, productData } = props;

  if ( productData === null ) {
    return <LoadingSpinner />;
  }

  return (
    <Row className="m-0 p-0">
      <Col md={ 12 } id="alert-tariff-page" className="px-0">
        <AppAlertUI />
      </Col>
      { subStep === 'subStep1' && (
        <TariffSubStep1
          formData={ lead.subStep1TariffData }
          storeDevices={ lead.subStep1DeviceItems }
          productData={ productData }
        />
      ) }
      { subStep === 'subStep2' && (
        <TariffSubStep2
          productCode={ productCode }
          lead={ lead }
          isNotDataSubStep1={ lead.subStep1TariffData === null }
          productData={ productData }
        />
      ) }
    </Row>
  );
};
